import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import es from "element-plus/es/locale/lang/es";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import { filters } from "@/core/helpers/utils";
import "@/core/plugins/prismjs";
import { abilitiesPlugin } from "@casl/vue";
import { ability } from "@/core/helpers/ability";

const app = createApp(App);
app.use(abilitiesPlugin, ability, {
  useGlobalProperties: true,
});
app.use(store);
app.use(router);
app.use(ElementPlus, { locale: es });

app.config.globalProperties.$filters = filters;

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
